import { Link } from 'react-router-dom';

export function DesktopNav({ navLinks, isDark }) {
    return (
        <nav className="hidden lg:flex items-center gap-5" data-testid="desktop-nav">
            {navLinks.map((link) => (
                <Link
                    key={link.href}
                    to={link.href}
                    data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className={`font-inter text-sm font-medium tracking-wide transition-colors duration-200 ${
                        isDark
                            ? 'text-white/90 hover:text-white'
                            : 'text-gray-700 hover:text-navy-900'
                    }`}
                >
                    {link.label}
                </Link>
            ))}
            <Link
                to="/contact"
                data-testid="nav-cta-button"
                className="bg-gold-400 text-white px-5 py-2.5 text-sm font-semibold tracking-wide rounded-sm hover:bg-gold-500 transition-colors duration-200 shadow-sm"
            >
                Book a Diagnostic Call
            </Link>
        </nav>
    );
}
